import { Colors, FontSizePx, Spacing } from '@kvika/audur-theme'
import styled from 'styled-components'

export const RowContainer = styled.div`
	padding-inline: ${Spacing.Medium}px;
	border-bottom: 1px solid ${Colors.LightGray};
`

export const RowData = styled.div`
	display: flex;
	padding-block: ${Spacing.Medium}px;
`

export const Cell = styled.div<{ align?: 'flex-start' | 'flex-end' }>`
	display: flex;
	flex: 1;
	padding-right: ${Spacing.XSmall}px;
	align-items: center;
	justify-content: ${(props) => props.align || 'flex-start'};
	font-size: ${FontSizePx.Body}px;
	color: ${Colors.DarkGray};
`
